import React, { createContext, useState } from 'react';

import avatar from '@clint-core/commons/src/utils/avatar';
import logoDefault from '../assets/img/brand/white/logo_clint_symbol.svg';
import botAvatarDefault from '../assets/img/mariana.png';

export const OptionContext = createContext();

const getUrlParams = (url) => {
  const params = {};
  const parser = document.createElement('a');
  parser.href = url;
  const query = parser.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i += 1) {
    const pair = vars[i].split('=');
    params[pair[0]] = decodeURIComponent(pair[1]);
  }
  return params;
};

const OptionProvider = ({ children, option }) => {
  const randomInt = Math.floor(Math.random() * 31);
  const gender = randomInt % 2 === 0 ? 'male' : 'female';
  const isAdmin = !!getUrlParams(window.location.href)?.admin;
  const displayOptions = {
    input: 'dialog-input-display',
    inputSuggestions: 'dialog-input-display',
    singleButton: 'dialog-single-button-display',
  };
  const [display, setDisplay] = useState(displayOptions.input);

  const [header] = useState(option?.header || {
    icon: logoDefault,
    iconSize: '23px',
    background: '#6c19de',
    foreground: '#FFF',
  });

  const [dialog] = useState(option?.dialog || {
    userAvatar: avatar[`avatar/${gender}/${randomInt}`],
    botAvatar: botAvatarDefault,
    foreground: '#000',
  });

  const [input] = useState(option?.input || {
    foreground: '#000',
    background: {
      colorA: '#f7f6fe',
      colorB: '#fafbff',
    },
    button: {
      background: '#6c19de',
      foreground: '#ffffff',
    },
    rating: {
      willBeActive: '#c89fff',
    },
  });

  return (
    <OptionContext.Provider value={{ header, dialog, input, global, display, isAdmin, setDisplay, displayOptions }}>
      {children}
    </OptionContext.Provider>
  );
};

export default OptionProvider;
